import axios from "axios";
import config from "../config";
import authHeader from "./auth-header";

const API_URL = config.API_URL;

const getUser = () => {
  const action = `afterlogin/user`;
  return axios.post(API_URL + action, {}, { headers: authHeader() });
};
const userupdate = (values) => {
  const formData = new FormData();
  for (let value in values) {
    if (["gender"].includes(value) && values[value] && typeof values[value] === "object") {
      formData.append(value, values[value].value);
    } else {
      formData.append(value, ["email", "confirmemail"].includes(value) && typeof values[value] === "string" ? values[value].trim() : values[value]);
    }
  }
  const action = "afterlogin/auth/userupdate";
  return axios.post(API_URL + action, formData, { headers: authHeader({ contentType: "multipart/form-data" }) });
};

const changeemail = (values) => {
  const formData = new FormData();
  for (let value in values) {
    if (["gender"].includes(value) && values[value] && typeof values[value] === "object") {
      formData.append(value, values[value].value);
    } else {
      formData.append(value, ["email", "confirmemail"].includes(value) && typeof values[value] === "string" ? values[value].trim() : values[value]);
    }
  }
  const action = "afterlogin/auth/changeemail";
  return axios.post(API_URL + action, formData, { headers: authHeader({ contentType: "multipart/form-data" }) });
};

const changepassword = (values) => {
  const formData = new FormData();
  for (let value in values) {
    if (["gender"].includes(value) && values[value] && typeof values[value] === "object") {
      formData.append(value, values[value].value);
    } else {
      formData.append(value, values[value]);
    }
  }
  const action = "afterlogin/auth/changepassword";
  return axios.post(API_URL + action, formData, { headers: authHeader({ contentType: "multipart/form-data" }) });
};

const userApiController = {
  getUser,
  userupdate,
  changeemail,
  changepassword,
};

export default userApiController;
